import { forwardRef, useImperativeHandle, useState } from "react"

import BlurWrapper from "@fuse/sharedComponents/blurWrapper"

import { DeviceTypes, DownloadLinkMap } from "@fuse/utils/DeviceDection"

import appStore from "@fuse/assets/images/img-app-store.svg"
import playStore from "@fuse/assets/images/img-play-store.svg"

export interface AdminDownloadAppModalHandle {
  openModal: () => void
  closeModal: () => void
}

const AdminDownloadAppModal = forwardRef<AdminDownloadAppModalHandle>(
  (_, ref) => {
    const [isVisible, setIsVisible] = useState(false)

    // Expose methods to parent via ref
    useImperativeHandle(ref, () => ({
      openModal: () => {
        setIsVisible(true)
      },
      closeModal: () => {
        setIsVisible(false)
      },
    }))

    if (!isVisible) return null

    const handleButtonClick = (url: string) => {
      window.open(url, "_blank")
    }
    const isEventDetailPage = window.location.pathname.includes("events")

    const top =
      "fixed inset-0 flex justify-center items-start bg-black bg-opacity-50 z-[100] pt-80"
    const bottom =
      "fixed inset-0 flex justify-center bg-black bg-opacity-50 z-[100] items-end md:items-center place-items-center"

    return (
      <div
        className={isEventDetailPage ? top : bottom}
        onClick={() => setIsVisible(false)}
      >
        <BlurWrapper
          overlayOpacityDefault="20"
          className="w-full md:max-w-sm !bg-gray-500/10 rounded-t-2xl md:rounded-2xl p-4 relative flex flex-col cursor-auto place-content-center"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex flex-col items-center justify-center gap-5 py-4">
            <p className="text-white text-6xl font-medium">👀</p>

            <p className="text-white">
              To view and manage your guest
              <br /> list, please use the app.
              <br />
              <br />
              Download now to unlock this <br />
              feature.
            </p>

            <div className="flex flex-row gap-5">
              <img
                src={appStore}
                alt="App Store"
                className="h-10"
                onClick={() =>
                  handleButtonClick(DownloadLinkMap[DeviceTypes.IOS])
                }
              />
              <img
                src={playStore}
                alt="Google Play"
                className="h-10"
                onClick={() =>
                  handleButtonClick(DownloadLinkMap[DeviceTypes.ANDROID])
                }
              />
            </div>
          </div>
        </BlurWrapper>
      </div>
    )
  },
)

export default AdminDownloadAppModal
